import { render, staticRenderFns } from "./ObserveEmitter.vue?vue&type=template&id=0ea1469f&"
import script from "./ObserveEmitter.vue?vue&type=script&lang=js&"
export * from "./ObserveEmitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports